<div
  class="card"
  [ngClass]="{ 
'scale-in': isStatus('created'),
'scale-out': isStatus('deleted'),
'init_status': isStatus('init'),
'editing': isStatus('editing'),
'updated': isStatus('updated'),
'cancelled': isStatus('cancelled'),
}"
>
  <div class="header">
    <p class="title">{{ lastNotNullValue.label }}</p>
    <div class="card-actions">
      @if (isStatus('editing')) {
      <button class="confirm-button" (click)="saveChanges()">
        <mat-icon> check </mat-icon>
      </button>
      <button class="cancel-button" (click)="cancelChanges()">
        <mat-icon (click)="cancelChanges()">close</mat-icon>
      </button>
      } @else {
      <button class="delete-button" (click)="onDeleteClick()">
        <img src="assets/static/icons/delete.svg" alt="" />
      </button>
      <button class="edit-button" (click)="onEditClick()">
        <img src="assets/static/icons/edit.svg" alt="" />
      </button>
      }
    </div>
  </div>
  <div class="card-grid mt-2">
    @for (item of lastNotNullValue.items; track $index) {
    <div class="card-grid-item">
      <div class="item-label">{{ item.label }}</div>
      <div class="item-value" *ngIf="!isStatus('editing')">
        {{ item.value }}
      </div>
      <input
        *ngIf="isStatus('editing')"
        [(ngModel)]="item.value"
        class="card-input"
      />
    </div>
    }
  </div>
</div>
